import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

const ANIMATIONS = {
  search: 'https://lottie.host/2b249767-5e9c-4613-b702-1b3b0f1b1a0f/Vy4dtEYxQj.json',
  empty: 'https://lottie.host/9a0f06c3-f65c-4adf-9060-3106e2c9b498/ULx4jRABk7.json',
  docs: 'https://lottie.host/f5f1e623-b tried-4ad4-b5d0-0ae5db0f4f91/placeholder.json',
  check: 'https://lottie.host/e5bce503-c4c4-4b56-adc4-cf6f58d9dbb1/JI3hKkBViv.json',
};

// Inline fallback SVG animation for when Lottie URLs don't load
function FallbackAnimation({ type }) {
  const colors = { search: '#003366', empty: '#526071', docs: '#f5a800', check: '#1e8c45' };
  const color = colors[type] || '#526071';
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" className="mx-auto opacity-30">
      <circle cx="60" cy="60" r="45" fill="none" stroke={color} strokeWidth="2" strokeDasharray="8 4" opacity="0.4">
        <animateTransform attributeName="transform" type="rotate" from="0 60 60" to="360 60 60" dur="8s" repeatCount="indefinite" />
      </circle>
      <circle cx="60" cy="60" r="25" fill="none" stroke={color} strokeWidth="1.5" opacity="0.3">
        <animateTransform attributeName="transform" type="rotate" from="360 60 60" to="0 60 60" dur="6s" repeatCount="indefinite" />
      </circle>
      <circle cx="60" cy="60" r="6" fill={color} opacity="0.2">
        <animate attributeName="r" values="6;8;6" dur="2s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}

export default function EmptyState({ type = 'empty', title, subtitle, action, children }) {
  const [useFallback, setUseFallback] = React.useState(false);
  const lottieUrl = ANIMATIONS[type];

  return (
    <div className="flex flex-col items-center justify-center py-10 px-4 text-center" data-testid={`empty-state-${type}`}>
      <div className="w-32 h-32 mb-4">
        {!useFallback && lottieUrl ? (
          <Player
            autoplay
            loop
            src={lottieUrl}
            style={{ width: 128, height: 128 }}
            onEvent={(e) => { if (e === 'error') setUseFallback(true); }}
          />
        ) : (
          <FallbackAnimation type={type} />
        )}
      </div>
      {title && <p className="text-sm font-medium text-[#0b1220] mb-1">{title}</p>}
      {subtitle && <p className="text-xs text-[#526071] max-w-[280px]">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
      {children}
    </div>
  );
}
